import { useAtom } from 'jotai';

import { ISelfResponse } from '@/shared/interfaces';
import { fetchProfileQueryAtom } from '@/features/profile/MinorChildren/state/fetchProfileQueryAtom';
import { atom } from 'jotai/index';
import { QueryObserverResult } from '@tanstack/react-query';

type ProfileResponse = {
    profile: ISelfResponse | undefined;
    status: 'pending' | 'success' | 'error' | 'idle';
    refetch: () => Promise<
        QueryObserverResult<ISelfResponse | undefined, Error>
    >;
    errorMessage: string | null;
};

const profileFetchedAtom = atom(false);

// Custom hook to fetch the profile
export const useProfile = (): ProfileResponse => {
    const [{ refetch, error, data, status }] = useAtom(fetchProfileQueryAtom);
    const [isFetched, setIsFetched] = useAtom(profileFetchedAtom);

    return {
        profile: data, // The fetched profile data
        status: isFetched ? status : 'idle', // The query status (loading, success, error): override this status to not have it set to 'pending' initially
        refetch: async () => {
            const refetchedData = await refetch();
            setIsFetched(true);
            return refetchedData; // Return the latest profile data
        },
        errorMessage: error instanceof Error ? error.message : null,
    };
};
